var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "box" }, [
      _c(
        "div",
        { staticClass: "map", attrs: { id: "container" } },
        [
          _c(
            "baidu-map",
            {
              staticClass: "bm-view",
              attrs: { center: _vm.formData.shopAdress, zoom: _vm.zoom },
              on: { ready: _vm.handler }
            },
            [
              _c("bm-geolocation", {
                attrs: {
                  anchor: "BMAP_ANCHOR_BOTTOM_RIGHT",
                  showAddressBar: true,
                  autoLocation: true
                }
              }),
              _vm._v(" "),
              _c("bm-navigation", {
                attrs: { anchor: "BMAP_ANCHOR_TOP_RIGHT" }
              }),
              _vm._v(" "),
              _c(
                "bm-marker",
                {
                  attrs: {
                    position: { lng: 116.404, lat: 39.915 },
                    dragging: false,
                    animation: "BMAP_ANIMATION_BOUNCE"
                  },
                  on: {
                    mouseover: _vm.infoWindowOpen,
                    mouseout: _vm.infoWindowClose
                  }
                },
                [
                  _c(
                    "bm-info-window",
                    {
                      attrs: { show: _vm.show },
                      on: {
                        close: _vm.infoWindowClose,
                        open: _vm.infoWindowOpen
                      }
                    },
                    [_vm._v(_vm._s(_vm.formData.shopAdress))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "information" }, [
        _c("span", { staticClass: "contype" }, [_vm._v("联系方式")]),
        _vm._v(" "),
        _vm.formData.chargePersonName
          ? _c("div", { staticClass: "people" }, [
              _c("i", { staticClass: "icon-add14" }),
              _vm._v(" "),
              _c("span", { staticClass: "mingzi" }, [_vm._v("联系人: ")]),
              _vm._v(" "),
              _c("span", { staticClass: "mingzi" }, [
                _vm._v(_vm._s(_vm.formData.chargePersonName))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.formData.chargePersonPhone
          ? _c("div", { staticClass: "people" }, [
              _c("i", { staticClass: "icon-add13" }),
              _vm._v(" "),
              _c("span", { staticClass: "mingzi" }, [_vm._v("联系电话: ")]),
              _vm._v(" "),
              _c("span", { staticClass: "mingzi" }, [
                _vm._v(_vm._s(_vm.formData.chargePersonPhone))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.formData.shopWechat
          ? _c("div", { staticClass: "people" }, [
              _c("i", { staticClass: "icon-add17" }),
              _vm._v(" "),
              _c("span", { staticClass: "mingzi" }, [_vm._v("微信: ")]),
              _vm._v(" "),
              _c("span", { staticClass: "mingzi" }, [
                _vm._v(_vm._s(_vm.formData.shopWechat))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.formData.shopAdress
          ? _c("div", { staticClass: "possition" }, [
              _c("span", { staticClass: "contype" }, [_vm._v("联系地址")]),
              _vm._v(" "),
              _c("div", { staticClass: "people" }, [
                _c("i", { staticClass: "icon-positioning" }),
                _vm._v(" "),
                _c("span", { staticClass: "mingzi" }, [_vm._v("地址: ")]),
                _vm._v(" "),
                _c("span", { staticClass: "mingzi" }, [
                  _vm._v(_vm._s(_vm.formData.shopAdress))
                ])
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-5fdfd0d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5fdfd0d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/contact.vue
// module id = null
// module chunks = 